import React from 'react';

import EventDebuggerTableHeader from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableHeader';
import { useEventDebuggerTableContext } from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext';
import eventDebuggerTableColumns from './eventDebuggerTableColumns';

const CLUSTER_REQUIRED_MESSAGE = 'Please select a cluster.';
const PACKET_SIZE_ERROR_MESSAGE =
  'The data returned was too large to retrieve. Please reduce the number of events displayed using the "Events" dropdown above.';

const STATIC_TABLE_PROPS = {
  pagination: true,
  columns: eventDebuggerTableColumns,
  customHeader: true,
};

export default function useEventDebuggerTableProps() {
  const { cluster, events, eventsLoading, packetSizeTooLarge } = useEventDebuggerTableContext();

  return {
    ...STATIC_TABLE_PROPS,
    loading: eventsLoading,
    paginationResetDefaultPage: eventsLoading,
    ...buildNoDataComponent({ cluster, packetSizeTooLarge }),
    data: events,
    title: <EventDebuggerTableHeader />,
  };
}

function buildNoDataComponent({ cluster, packetSizeTooLarge }) {
  if (!cluster) {
    return { noDataComponent: CLUSTER_REQUIRED_MESSAGE };
  }

  if (packetSizeTooLarge) {
    return { noDataComponent: PACKET_SIZE_ERROR_MESSAGE };
  }

  return;
}
